module.exports = __webpack_public_path__ + "media/images/flags/gt-ccfc27d34052eec1eb6ecfa9805ae620.svg";